import { Box } from '@material-ui/core';
import React from 'react';
import ServiceGrid from '../ServiceGrid';
import TransactionsChart from './TransactionsChart';

const Dashboard = (props: any) => {
  return (
    <Box overflow="hidden" width="100%">
      {/* <KPIChart /> */}
      <TransactionsChart {...props} />
      <ServiceGrid />
    </Box>
  );
};

export default Dashboard;
